import { Component, OnInit, ViewEncapsulation,  ChangeDetectionStrategy } from '@angular/core';
import { Url } from '../common';

@Component({
    selector: 'version',
    templateUrl: './version.component.html',
})
export class VersionComponent implements OnInit {
    url = Url;
    appVersion:string='';
    ngOnInit(): void {
        this.appVersion=this.url.appVersion;
    }
}